import { axiosInstance } from "../../../../Services";
import { MMH_PRODUCTS_BASE_PATH, USE_MOCK } from "./config";
import { mockGetProducts } from "../mock/mockApi";

// READ (list) — GET /internal/mmh-products?page=&limit=&search=&...filters
// Resolves to { data: { data: [...], total, page, limit } }.
export const GetMMHProducts = async ({ page = 1, limit = 10, search = "", filters = {} } = {}) => {
  if (USE_MOCK) {
    return mockGetProducts({ page, limit, search, filters });
  }

  const params = { page, limit };

  if (search) {
    params.search = search;
  }

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value !== "" && value !== null && value !== undefined) {
      params[key] = value;
    }
  });

  return axiosInstance.get(`${MMH_PRODUCTS_BASE_PATH}`, { params });
};

export default GetMMHProducts;
